import { useState, useEffect, useContext } from "react";
import { Input } from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function Configuration(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setLoading(false);
    Repo.getConfiguration(apiToken)
      .then((response) => {
        setData(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const validateConfiguration = () => {
    setValidation(true);
    let passedValidation = true;

    Object.entries(data).map(([key, value]) => {
      //isArray is used to exclude the isees array in the validation
      if (value === "") {
        passedValidation = false;
      }
    });

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const updateConfiguration = () => {
    Repo.postUpdateConfiguration(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/configurazione";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>

<h1>Configurazione</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Parametri per la configurazione del file Excel di MyPay. </p>
          </div>

<div className="row mt-3">

<div className="form-group col-md-4">
<Input
                    id="azione"
                    disabled={isDisabled}
                    label="Azione*"
                    type="text"
                    name="azione"
                    value={data ? data.azione : ""}
                    {...(validation &&
                      !data.azione && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({ ...data, azione: e.target.value })
                    }
                  />

</div>

<div className="form-group col-md-4">
<Input
                    id="codUfficio"
                    disabled={isDisabled}
                    label="Codice Ufficio*"
                    type="text"
                    name="codUfficio"
                    value={data ? data.codUfficio : ""}
                    {...(validation &&
                      !data.codUfficio && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({ ...data, codUfficio: e.target.value })
                    }
                  />
</div>

<div className="form-group col-md-4">

<Input
                    id="codeConfig"
                    disabled={isDisabled}
                    label="Codice Configurazione*"
                    type="text"
                    name="codeConfig"
                    value={data ? data.codeConfig : ""}
                    {...(validation &&
                      !data.codeConfig && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({ ...data, codeConfig: e.target.value })
                    }
                  />

</div>

<div className="form-group col-md-4">
                  <div className="bootstrap-select-wrapper">
                    <label htmlFor="selectExampleDisabled">
                      Flag Genera Iuv*
                    </label>
                    <Select
                      defaultMenuIsOpen={false}
                      isDisabled={isDisabled}
                      icon={false}
                      name="flgGeneraIuv"
                      id="flgGeneraIuv"
                      options={[
                        { value: true, label: "true" },
                        { value: false, label: "false" },
                      ]}
                      onChange={(e) =>
                        setData({ ...data, flgGeneraIuv: e.value })
                      }
                      placeholder={data ? data.flgGeneraIuv.toString() : ""}
                    />
                    {validation && !data.flgGeneraIuv && (
                      <div className="Il campo non può essere vuoto!"></div>
                    )}
                  </div>
                  </div>

<div className="form-group col-md-4">

<Input
                    id="tipoDovuto"
                    disabled={isDisabled}
                    label="Prefisso Tipo Dovuto*"
                    type="text"
                    name="tipoDovuto"
                    value={data ? data.tipoDovuto : ""}
                    {...(validation &&
                      !data.tipoDovuto && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({ ...data, tipoDovuto: e.target.value })
                    }
                  />

</div>


<div className="form-group col-md-4">


<Input
                    id="tipoIdentificativoUnivoco"
                    disabled={isDisabled}
                    label="Tipo Identificativo Univoco*"
                    type="text"
                    name="tipoIdentificativoUnivoco"
                    value={data ? data.tipoIdentificativoUnivoco : ""}
                    {...(validation &&
                      !data.tipoIdentificativoUnivoco && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({
                        ...data,
                        tipoIdentificativoUnivoco: e.target.value,
                      })
                    }
                  />

</div>


<div className="form-group col-md-4">

<Input
                    id="datiSpecificiRiscossione"
                    disabled={isDisabled}
                    label="Dati Specifici Riscossione*"
                    type="text"
                    name="datiSpecificiRiscossione"
                    value={data ? data.datiSpecificiRiscossione : ""}
                    {...(validation &&
                      !data.datiSpecificiRiscossione && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({
                        ...data,
                        datiSpecificiRiscossione: e.target.value,
                      })
                    }
                  />

</div>

<div className="form-group col-md-4">
<Input
                    id="tipoVersamento"
                    disabled={isDisabled}
                    label="Tipo Versamento*"
                    type="text"
                    name="tipoVersamento"
                    value={data ? data.tipoVersamento : ""}
                    {...(validation &&
                      !data.tipoVersamento && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setData({ ...data, tipoVersamento: e.target.value })
                    }
                  />

</div>


<div className="form-group col-md-4 text-right">

{isDisabled ? (
             
                  
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => setIsDisabled(!isDisabled)}
                      title="Modifica"
                    >
                      Modifica
                    </button>
                 
             
              ) : (<span>
               
                  
                    <button
                      type="button"
                      className="btn btn-outline-secondary m-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => setIsDisabled(!isDisabled)}
                      title="Indietro"
                    >
                      Indietro
                    </button>
                
               
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => validateConfiguration()}
                      title="Conferma"
                    >
                      Conferma
                    </button>
                    </span>
                
              )}

</div>




</div>

 
       
 
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica configurazione"
        body="Confermi di voler modificare la configurazione dell'applicativo?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => updateConfiguration()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </div>
  );
}

export default Configuration;
